import { render, staticRenderFns } from "./PackageCompTest.vue?vue&type=template&id=1e338a1a&scoped=true"
import script from "./PackageCompTest.vue?vue&type=script&lang=js"
export * from "./PackageCompTest.vue?vue&type=script&lang=js"
import style0 from "./PackageCompTest.vue?vue&type=style&index=0&id=1e338a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e338a1a",
  null
  
)

export default component.exports